/**
 * One composed print (a digital receipt), by its signed view token.
 *
 * Read once: a print is a record of what was composed at that moment and does
 * not change, so there is no poll and no refetch on focus. A miss is final —
 * the link expired or never existed — and is not retried.
 */
import { useQuery } from '@tanstack/react-query';

import { getPrintView, isPrintViewMiss } from '../services/publicPrintViews';

export const printViewKeys = {
  all: ['printView'] as const,
  view: (token: string) => [...printViewKeys.all, 'view', token] as const,
};

export function usePrintView(token: string) {
  return useQuery({
    queryKey: printViewKeys.view(token),
    queryFn: () => getPrintView(token),
    enabled: !!token,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => !isPrintViewMiss(error) && failureCount < 2,
  });
}
